/**
 * @param {string} eventCategory - The category of the tracked event.
 * @param {string} eventAction - The action associated with the event.
 * @param {string} eventName - The name of the event.
 * @param {number} eventValue - The value to track (e.g., an index).
 */

const MatomoTrackRequest = (
  eventCategory,
  eventAction,
  eventName,
  eventValue
) => {
  var _mtm = (window._mtm = window?._mtm || []);
  eventCategory = eventCategory || window?.location?.href;
  eventAction = eventAction || 'TrackAction';

  _mtm.push({
    event: 'clickEvent',
    eventCategory,
    eventAction,
    eventName,
    eventValue,
  });
};
export default MatomoTrackRequest;
